import {adjustTextAlignment} from "../utils/helpers";

export default class PopupTapestry {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        let $this = this;
        $('body').on('click', '.tapestry_card', function (e) {
            let name = $(this).find('.tapestry_card__title h5').text();
            let location = $(this).find('.tapestry_card__location').clone();
            const quoteElement = $(this).find('.tapestry_card__quote .jet-listing-dynamic-field__content');
            let quote = quoteElement.html();
            let source = $(this).find('.tapestry_card__source .jet-listing-dynamic-field__content').html();
            let video = $(this).find('.tapestry_card__video .jet-listing-dynamic-field__content').text();
            let text = $(this).find('.tapestry_card__text .jet-listing-dynamic-field__content').html();
            let image = $(this).find('.tapestry_card__image img').clone();
            const $popup = $('.popup-tapestry');
            const $quoteElement = $('.popup-tapestry__quote');
            const $sourceElement = $('.popup-tapestry__source');

            $quoteElement.empty().removeClass('d-none').css({'display': '', 'visibility': ''});
            $sourceElement.empty().removeClass('d-none').css({'display': '', 'visibility': ''});

            $popup.addClass('open');
            $('.popup-tapestry__name').html(name);
            $('.popup-tapestry__country').html(location);
            $('.popup-tapestry__text').html(text);
            
            if (quote) {
                $quoteElement.addClass('popup-tapestry__quote')
                    .html(quote)
                    .css({'display': 'block', 'visibility': 'visible'});
            } else {
                $quoteElement.html('').addClass('d-none').css('display', 'none');
            }
            
            if (source) {
                $sourceElement.addClass('popup-tapestry__source')
                    .html(source)
                    .css({'display': 'block', 'visibility': 'visible'});
            } else {
                $sourceElement.html('').addClass('d-none').css('display', 'none');
            }
            if (video) {
                video = $this.youtube_parser(video);
                const iframe = document.createElement("iframe");
                iframe.src = 'https://www.youtube.com/embed/' + video + '?rel=0&autoplay=1';
                iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                $('.popup-tapestry__left').html(iframe);
            } else {
                $('.popup-tapestry__left').html(image);
            }

            if (image) {
                const popUpImage = $('.popup-tapestry__left img');

                if (popUpImage.height() > 500) {
                    popUpImage.addClass('tall-image');
                }
            }

            if (adjustTextAlignment !== undefined) {
                adjustTextAlignment();
            }
        })

        $('.popup-tapestry__rgba, .popup-tapestry__close').on('click', function (e) {
            $('.popup-tapestry').removeClass('open');
            // Stop video by clearing the iframe
            $('.popup-tapestry__left').html('');
            // Completely reset the quote and source elements
            $('.popup-tapestry__quote, .popup-tapestry__source').empty();
        });

    }

    youtube_parser(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }
}